import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CookiesService } from './cookies.service';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { encryptedAESKey } from 'src/app/shared/helpers/encryption';
import { GenericResponse } from 'src/app/shared/interface/generic.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfigEnviromentService {

  private _configReady = new BehaviorSubject<boolean>(false);
  configReady$ = this._configReady.asObservable();
  _loadUser = new BehaviorSubject<boolean>(true)
  _loadUser$ = this._loadUser.asObservable();

  constructor(
    private http: HttpClient,
    private cookiesService: CookiesService
  ) {}

  async loadConfig(): Promise<void> {
    return new Promise(async (resolve) => {
      try {
        
        const hostname = this.obtenerHostname();
        this.cookiesService.cookieNameEnv = `8y43jvbjbv${hostname}`;
        const cookieName = this.cookiesService.cookieNameEnv;

        const subdomain = this.obtenerSubdominio(hostname);
        const apiUrl = this.obtenerApiUrl(subdomain);

        
        const cachedEnv = this.cookiesService.getCookie(cookieName);
        if (cachedEnv) {
          try {
            const parsed = JSON.parse(cachedEnv);
            Object.assign(environment, parsed);
            this._configReady.next(true);
            resolve();
            return;
          } catch (e) {
            console.warn('Cookie de configuración inválida, se eliminará y recargará.', e);
            this.cookiesService.deleteCookie(cookieName);
          }
}

        const publicKey = await this.PubKey(apiUrl);
        const encryptedKeys = await encryptedAESKey(publicKey.data);

        const body = {
          sEncryptedData: arrayBufferToBase64(encryptedKeys[0])
        };

        const sendEncryptedKey = await this.sendEncryptedKey(apiUrl, body);

        const decryptedRaw = await decrypt(
          sendEncryptedKey.data,
          encryptedKeys[1]
        );

        const decryptedEnv = JSON.parse(
          decryptedRaw.replace(/,\s*}/g, '}')
        );

        decryptedEnv.api_url = apiUrl + '/';

        Object.assign(environment, decryptedEnv);

        this._configReady.next(true);
        resolve();
      } catch (error) {
        
        let err = error
        //console.log(err)
        this._configReady.next(true);
        resolve();
      }
    });
  }

  waitUntilReady(): Promise<void> {
    return new Promise((resolve) => {
      const sub = this.configReady$.subscribe((ready) => {
        if (ready) {
          sub.unsubscribe();
          resolve();
        }
      });
    });
  }

  obtenerHostname(): string {
    return window.location.hostname;
  }

  obtenerSubdominio(hostname: string): string {
    const parts = hostname.split('.');

    if (parts.length === 1) return parts[0];
    if (parts.length === 2 && parts[1] === 'localhost') return 'localhost';
    if (parts.length === 3 && parts[2] === 'localhost') return 'localhost';
    if (parts.length === 3) return parts[0];
    if (parts.length === 4) return parts[1];

    throw new Error('Invalid hostname');
  }

  obtenerApiUrl(subdomain: string): string {
    
    switch (subdomain) {
      case 'localhost':
        return 'https://localhost:44333';
      case 'dev':
        return 'https://api.am.dev.appsmart.pe';
      case 'qa':
        return 'https://api.am.qa.appsmart.pe';
      case 'qa2':
        return 'https://api.am.qa2.appsmart.pe';
      default:
        return 'https://api.infomedsoat.asecom.pe';
    }
  }

  async PubKey(apiUrl: string) {
    
    return lastValueFrom(this.http
      .get<GenericResponse<string>>(
        `${apiUrl}/api/configuraciones/getpubkey`
      ))
      ;
  }

  async sendEncryptedKey(
    apiUrl: string,
    body: { sEncryptedData: string }
  ): Promise<any> {
    return this.http
      .post(`${apiUrl}/api/configuraciones/receive_encrypted_key`, body)
      .toPromise();
  }
}

function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  bytes.forEach(b => binary += String.fromCharCode(b));
  return btoa(binary);
}

function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

async function decrypt(
  jsonStringFromBackend: string,
  rawAesKey: ArrayBuffer
): Promise<string> {

  const payload = JSON.parse(jsonStringFromBackend);

  const cipherText = new Uint8Array(base64ToArrayBuffer(payload.Item1));
  const iv = new Uint8Array(base64ToArrayBuffer(payload.Item2));
  const tag = new Uint8Array(base64ToArrayBuffer(payload.Item3));

  const encryptedData = new Uint8Array(cipherText.length + tag.length);
  encryptedData.set(cipherText);
  encryptedData.set(tag, cipherText.length);

  const aesKey = await crypto.subtle.importKey(
    'raw',
    rawAesKey,
    { name: 'AES-GCM' },
    false,
    ['decrypt']
  );

  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv },
    aesKey,
    encryptedData
  );

  return new TextDecoder().decode(decryptedBuffer);
}
